import {fetchJSONIslandData} from '../helpers/json-island'

/**
 * Determines if Copilot functionality should be shown in projects.
 * This checks the high-level Copilot SWE flag to ensure features are only
 * shown when Copilot is available in the environment.
 *
 * @returns boolean indicating whether Copilot functionality should be shown
 */
export function shouldShowCopilotFunctionalityInProjects(): boolean {
  const appPayload = fetchJSONIslandData('app-payload')
  // Default to false - only show when explicitly enabled
  return appPayload?.current_user_settings?.copilot_show_functionality ?? false
}
